module.exports = __webpack_public_path__ + "static/media/man_jinlvyan.e8c96a7b.png";